__turbopack_context__.v({
  "button": "PlasmicButtonBarItem-module__xs5j5a__button",
  "buttonselected": "PlasmicButtonBarItem-module__xs5j5a__buttonselected",
  "freeBox": "PlasmicButtonBarItem-module__xs5j5a__freeBox",
  "slotTargetChildren": "PlasmicButtonBarItem-module__xs5j5a__slotTargetChildren",
  "slotTargetChildrenselected": "PlasmicButtonBarItem-module__xs5j5a__slotTargetChildrenselected",
});
